<template>
    <SeatingPlan
        :numberOfSeats="48"
        :doublePlaceholderBefore="[23, 25]"
    />
</template>

<script lang="ts" setup>
import SeatingPlan from './SeatingPlan.vue';
</script>
